// extracted by mini-css-extract-plugin
module.exports = {"pre":"Form_pre__2Bqvm"};